import React from 'react';
export function Footer() {
  return <footer className="w-full bg-deep-green border-t border-green-900 py-12 px-4 pb-24 md:pb-12" data-id="element-159">
      <div className="max-w-4xl mx-auto text-center" data-id="element-160">
        <div className="mb-6" data-id="element-161">
          <span className="text-white font-bold text-xl tracking-tight" data-id="element-162">
            🇧🇷 PORTUGUÉS 360™
          </span>
        </div>

        <p className="text-gold text-sm font-medium mb-2" data-id="element-163">
          El sistema de cátedra N°1 para docentes de Português en Argentina.
        </p>
        <p className="text-white/80 text-sm mb-8" data-id="element-164">
          Porque enseñar Português no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-white/90 text-sm mb-10" data-id="element-165">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-166">
            📧 soporte@portugues360.com
          </a>
          <span className="hidden sm:inline text-white/30" data-id="element-167">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-168">
            📲 @portugues360
          </a>
          <span className="hidden sm:inline text-white/30" data-id="element-169">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-170">
            🌐 www.portugues360.com
          </a>
        </div>

        <div className="text-white/40 text-xs mb-8 leading-relaxed max-w-md mx-auto" data-id="element-171">
          © Portugués 360™ 2026 — Todos los derechos reservados.
          <br data-id="element-172" />
          Prohibida la reproducción y redistribución sin autorización expresa.
        </div>

        <p className="text-gold italic text-sm font-medium" data-id="element-173">
          🇧🇷 "O próximo domingo pode ser diferente."
        </p>
      </div>
    </footer>;
}